import './shims-and-polyfills';
import * as commonEnums from './enums/index';
import * as cmxTypeguards from './typeguards/index';
import * as cmxConfiguaration from './configuration/index';
import * as commonActions from './actions/action-types';
import * as commonActionUtils from './actions/_action-utilities';
import * as eulaActions from './actions/eula.actions';
import * as improvementActions from './actions/improvements.actions';
import * as launchPageActions from './actions/launch-page.action';
import * as codeBenchActions from './actions/code-bench.actions';
import * as createCaseActions from './actions/create-case.actions';
import * as dictionaryUtilities from './actions/dictionary-utilities';
import * as mergeCasesActions from './actions/merge-cases.actions';
import * as attachDocsActions from './actions/attach-docs.actions';
import * as uiActions from './actions/ui.actions';
import * as xcaliberActions from './actions/xcaliber.actions';
import * as gradeBenchPanelActions from './actions/grade-bench-panel-actions';
import * as caseActions from './actions/cases.action';
import * as sessionActions from './actions/session.actions';
import * as caseEditsActions from './actions/case-edits.actions';
import { buildQualityAssessmentWorklistPath } from './actions/quality-assessment-navigation';
import * as navigationIntentActions from './actions/navigation-intent.action';
import { enrichingAnnotationHooks } from './hooks/enrichingAnnotationHooks';
import { useCodeSearch } from './hooks/codeSearchHooks';
import { useCreateTransaction, useCreateTransactionAndAddCode, useCodeAssessmentUpdate } from './hooks/cqaHooks';
import { useHandleRubricAnswerChange } from './hooks/useHandleRubricAnswerChange';
import * as spanSelectors from './core/amplify/selectors/span-selectors';
import * as resolverSelectors from './core/amplify/selectors/resolver-selectors';
import { getOptionsFromTree, getValueAtPath } from './core/workbench/generalized-form/path-utils';
import * as objectUtils from './core/object-utils';
import * as identifierUtils from './core/identifier-utils';
import * as documentUtils from './core/document-utils';
import { getCodeRequests, getInvoiceCodeRequests } from './core/artifacts';
import * as navigation from './core/navigation';
import * as authenticationContext from './core/authentication-context';
import * as cmxLocation from './core/location';
import * as cmxStrings from './core/strings/compare-strings';
import * as _cmxURL from './core/url';
import _HttpMethods from './enums/http-methods';
import * as _windowTeardownHandler from './core/lifecycle/teardown-handler';
import * as _userUtils from './core/user/user';
import abortController from './core/abort-controller';
import * as _cmxErrors from './core/errors';
import * as cmxNotes from './core/notes/index';
import * as _caseUtils from './core/case/case-utils';
import * as _caseArtifacts from './core/case/artifact-sets';
import * as _caseStatusStrings from './core/case/case-status-strings';
import * as _highlighterUtils from './core/highlighter/highlighter-utils';
import * as _cmxDateTime from './core/date-time/cmx-date-time';
import * as _bpmSteps from './core/case/bpm';
import * as _loadStates from './core/load-states';
import * as _api from './core/api/api';
import {
  resolveApiPath,
  resolveRequestInfo,
  isApiProxyRoutesEnabled,
  setRuntimeApiProxyRoutesEnabled
} from './core/api/path-resolver';
import * as _utils from './core/artifacts/utils';
import { loggerFactory } from './core/logger';
import { AuthHandler as _AuthHandler } from './core/api/auth';
import { ActivityMonitor as _ActivityMonitor } from './core/api/activity-monitor';
import * as sessionManagement from './core/session-manager/session-manager';
import _authHandler from './core/api/auth-handler';
import _ContentTypes from './enums/content-types';
import * as _chargeConverters from './core/charges/charge-converters';
import * as _chargeErrors from './core/charges/charge-errors';
import * as _chargeSummarizer from './core/charges/charge-summarizer';
export * from './core/charges/charge-codes';
export {
  PDF_VIEWER_MESSAGE_TYPES,
  isPdfViewerContentMessage,
  isPdfViewerReadyMessage
} from './core/pdf-viewer-messages';
export type {
  PdfViewerContentMessage,
  PdfViewerMessage,
  PdfViewerMessageType,
  PdfViewerReadyMessage
} from './core/pdf-viewer-messages';
import * as _dragManager from './core/drag/drag-manager';
import { cmxArtifacts } from './core/artifacts/index';
import { activationProcessor } from './core/evidence2/activation-processor';
import * as _toCapitalCase from './core/strings/toCapitalCase';
import {
  PatientAmplifyEncounterColumns,
  PatientEncounterDashboardColumns
} from './core/encounter/encounter-data';
import {
  PatientAmplifyEncounterColumns as PatientAmplifyEncounterColumnsv2,
  PatientEncounterDashboardColumns as PatientEncounterDashboardColumnsv2,
  PatientEncounterGradeBenchColumns as PatientEncounterGradeBenchColumnsv2
} from './core/encounter/encounter-datav2';
import * as appServiceLines from './core/service-lines';
import * as vitalware from './core/vitalware';
import * as dictionaries from './core/dictionaries/index';
import * as activity from './core/amplify/activity';
import * as CommonFields from './core/amplify/fixture/fields';
import {
  AssesmentSelect,
  RoleSelect,
  modifierAssessmentOptionsTreePath,
  modifierRoleOptionsTreePath
} from './core/amplify/fixture/fields';
import { authenticationChannel } from './core/authentication-channel/authentication-channel';
import { TokenRequestChannel } from './core/authentication-channel/token-request-channel';
import {
  filterAndAssembleArtifactList,
  isLinkable,
  sortInvoices,
  artifactsForDisplay
} from './core/artifacts/artifact-filters';
import { codeEditFilter } from './core/artifacts/code-edit-filter';
import { preprocessor } from './core/artifacts/preprocessor';
import { automatableTypes } from './configuration/artifacts';
import {
  isDisplayedFeature,
  linkableEvidenceTypes,
  isSubhighlight,
  isBlockHighlight,
  getDescription,
  hasSentence,
  isSingleSelection,
  isMultipleSelection,
  getFeature,
  getFeatureForSelection,
  buildEvidenceFeatures
} from './core/artifacts/feature-utils';
import { getCode, getArtifactDescripton } from './core/artifacts/lookup';
import { EvidenceManager } from './core/artifacts/evidence-manager';
import { getArtifactSet } from './core/case/artifact-sets';
import * as AmplifyProcessStates from './core/amplify/process-states';
import * as AmplifyState from './state/index';
import * as AmplifyCore from './core/amplify/index';
import * as AmplifyMiddlewares from './core/amplify/middlewares/index';
import * as AmplifyReducers from './core/amplify/reducers/index';
import { CodeGradingSections } from './core/amplify/state';
import * as workBench from './core/workbench';
import { conditionalUtils } from './core/amplify/index';
import dictionaryUtils from './core/amplify/utils/dictionary/dictionary-utils';
import * as configurationUtils from './core/configuration-utils';
import { toCapitalCase } from './core/strings/toCapitalCase';
import * as coderConfig from './core/amplify/actions/coder-config';
import { extractCodesFromInvoices, calculateAvailableCodes, calculateTextSelectionOffsets, mapExtractedCodetoSuggestedCode } from './core/amplify/utils/annotation/span-utils';
import { isElementVisible } from './utils/elements';
import { shouldAutoAdvanceWorklistAfterSubmit } from './core/amplify/utils/cursor-worklist-navigation';
// Re-export pxToRem from themes for backwards compatibility — @codametrix/ui-components
// built bundle still imports this from ui-common.
export { pxToRem } from '@codametrix/themes/chakra/biome';

export const dragManager = _dragManager;
export const HttpMethods = _HttpMethods;
export const cmxURL = _cmxURL;
export const windowTeardownHandler = _windowTeardownHandler;
export const userUtils = _userUtils;
export const cmxErrors = _cmxErrors;
export const caseUtils = _caseUtils;
export const caseArtifacts = _caseArtifacts;
export const CaseStatusStrings = _caseStatusStrings;
export const highlighterUtils = _highlighterUtils;
export const cmxDateTime = _cmxDateTime;
export const bpmSteps = _bpmSteps;
export const loadStates = _loadStates;
export const chargeConverters = _chargeConverters;
export const chargeErrors = _chargeErrors;
export const chargeSummarizer = _chargeSummarizer;
export const api = _api;
export {
  resolveApiPath,
  resolveRequestInfo,
  isApiProxyRoutesEnabled,
  setRuntimeApiProxyRoutesEnabled
};
export const AuthHandler = _AuthHandler;
export const ActivityMonitor = _ActivityMonitor;
export const ContentTypes = _ContentTypes;
export const authHandler = _authHandler;
export const Utils = _utils;

export {
  loggerFactory,
  identifierUtils,
  xcaliberActions,
  gradeBenchPanelActions,
  documentUtils,
  cmxNotes,
  cmxArtifacts,
  sessionManagement,
  AmplifyCore,
  AmplifyState,
  AmplifyProcessStates,
  AmplifyMiddlewares,
  AmplifyReducers,
  activity,
  authenticationChannel,
  TokenRequestChannel,
  dictionaries,
  vitalware,
  PatientAmplifyEncounterColumns,
  PatientEncounterDashboardColumns,
  PatientAmplifyEncounterColumnsv2,
  PatientEncounterDashboardColumnsv2,
  PatientEncounterGradeBenchColumnsv2,
  activationProcessor,
  abortController,
  appServiceLines,
  navigation,
  commonEnums,
  commonActionUtils,
  eulaActions,
  launchPageActions,
  navigationIntentActions,
  codeBenchActions,
  createCaseActions,
  dictionaryUtilities,
  improvementActions,
  uiActions,
  caseActions,
  sessionActions,
  caseEditsActions,
  mergeCasesActions,
  attachDocsActions,
  cmxTypeguards,
  cmxStrings,
  cmxConfiguaration,
  cmxLocation,
  authenticationContext,
  commonActions,
  objectUtils,
  getCodeRequests,
  CommonFields,
  CodeGradingSections,
  workBench,
  conditionalUtils,
  configurationUtils,
  dictionaryUtils,
  toCapitalCase,
  coderConfig,
  enrichingAnnotationHooks,
  useCodeSearch,
  useCreateTransaction,
  useCreateTransactionAndAddCode,
  useCodeAssessmentUpdate,
  useHandleRubricAnswerChange,
  spanSelectors,
  resolverSelectors,
  getOptionsFromTree,
  getValueAtPath,
  AssesmentSelect,
  RoleSelect,
  modifierAssessmentOptionsTreePath,
  modifierRoleOptionsTreePath,
  buildQualityAssessmentWorklistPath,
  extractCodesFromInvoices,
  mapExtractedCodetoSuggestedCode,
  calculateAvailableCodes,
  calculateTextSelectionOffsets,
  isElementVisible,
  shouldAutoAdvanceWorklistAfterSubmit
};

export const ASSIGNED_TO_ME = 'Assigned to Me' as const;
export const IN_CQA = 'IN_CQA' as const;
export const CQA_COMPLETE = 'CQA_COMPLETE' as const;
export const CQA_APPROVED = 'CQA_APPROVED' as const;

export type { ResolveCQAWorkitemResult } from './actions/grade-bench-panel-actions';
